
interface rgbToHexProps{
    r?:number,
    g?:number,
    b?:number
}


export const rgbToHex=({r,g,b}:rgbToHexProps):string=>{

    const toHex =(value?:number)=>Math.round((value||0)*255).toString(16).padStart(2,'0');

    
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;

}